// extracted by mini-css-extract-plugin
export default {"header":"index_header__brjku","list":"index_list__9Cuwj","item":"index_item__tOj25","icon":"index_icon__QwjBN","text":"index_text__HM5K7","more":"index_more__c09h9"};